const SocketConstant = {
  url: "socket",
  getBlockNameDone: "WorkItemGetBlockNameDone",
  renameBlockDone: "WorkItemRenameBlockNameDone",
  logoutUser: "LogoutUser",
  joinRoom: "JoinRoom",
};
export default SocketConstant;
